import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_s2gzfhxg44: FaireBrandEntity = {
  token: "b_s2gzfhxg44",
  type: "brand",
  name: "Global Bite Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/d7ddf25eeff8cdce13cc249b0595fb21b3d4298cbf0e308ced8e30619681fd5d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9917db017f3f4392a0ee9692516832d4f0b8fa29d7ec406b46ba64ac8ccc3926.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d7ddf25eeff8cdce13cc249b0595fb21b3d4298cbf0e308ced8e30619681fd5d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9917db017f3f4392a0ee9692516832d4f0b8fa29d7ec406b46ba64ac8ccc3926.png",
  location: "Denver, CO, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 234,
  isInsider: true,
  description:
    "Global Bite Co. is more than a brand; it's a global journey packed in every snack and sip. Founded by three friends, who are travelers with a zest for world flavors. Our mission is to unite cultures through taste. From the lively markets of Asia to the tranquil farms of Europe, we bring the world's diverse culinary stories to your doorstep. Each bite and gulp is an adventure, a taste of distant lands, crafted sustainably and shared joyfully. Join us in celebrating global diversity, one snack, one drink at a time. Welcome to a world where every flavor tells a story.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:55.803Z",
    importedBy: "entity-db-cli",
  },
};
